import type { ComponentType, ReactNode } from "react";

import { Page } from "~/v2/components/common/page";
import { MFAGuard } from "~/v2/components/MFAGuard/MFAGuard";
import App from "~/v2/pages";

interface LayoutProps {
  disableAppMenu?: boolean;
  headerContent?: ReactNode;
  noHeader?: boolean;
  requireMFAForAllAccounts?: boolean;
  showBrandInHeader?: boolean;
  showSearchInHeader?: boolean;
  component: ComponentType<Record<string, unknown>>;
  children?: ReactNode;
}

export const Layout = ({
  disableAppMenu = false,
  noHeader = false,
  requireMFAForAllAccounts = false,
  showBrandInHeader = false,
  showSearchInHeader = true,
  component: Component,
  children,
  ...rest
}: LayoutProps) => {
  return (
    <App>
      <Page noHeader={noHeader} disableAppMenu={disableAppMenu}>
        <MFAGuard requireMFAForAllAccounts={requireMFAForAllAccounts}>
          {Component && <Component {...rest} />}
          {children}
        </MFAGuard>
      </Page>
    </App>
  );
};

export default Layout;
